import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { ProgramChildsAPI } from '@business/api/program_childs';
import { ProgramId, ProgramSectionResponse, SectionId } from '@business/entities/programs';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class ProgramChildBloc extends BaseBloc {
  private readonly programChildRepo = new Repository<ProgramSectionResponse>({
    getItemId: item => item.id,
  });

  readonly programSections$ = this.programChildRepo.items$;
  readonly selectSection = this.programChildRepo.selectItem;

  onReset() {
    this.programChildRepo.reset();
  }

  fetchProgramSection = (id: ProgramId) => {
    return ProgramChildsAPI.fetchProgramSection(id).pipe(
      this.programChildRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_program_sections_error') }),
    );
  };

  createProgramSection = (data: Partial<ProgramSectionResponse>) => {
    return ProgramChildsAPI.createProgramSection(data).pipe(
      this.programChildRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('create_program_sections'),
      }),
    );
  };

  selectOneSection = (sectionId: SectionId) => {
    return ProgramChildsAPI.selectOneSection(sectionId).pipe(
      this.programChildRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_program_sections_error') }),
    );
  };

  deleteProgramSection = (id: SectionId) => {
    return showDeleteConfirmation('Delete Program Section', 'Do you really want to remove this Section?').pipe(
      switchMap(() => ProgramChildsAPI.deleteProgramSection(id)),
      this.programChildRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_program_section'),
      }),
    );
  };

  updateProgramSection = (id: SectionId, data: Partial<ProgramSectionResponse>) => {
    return ProgramChildsAPI.updateProgramSection(id, data).pipe(
      this.programChildRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_program_section'),
      }),
    );
  };

  sortProgramSection = (section: ProgramSectionResponse, fromPosition: any, toPosition: number, programId: ProgramId) => {
    return ProgramChildsAPI.sortProgramSection(section, fromPosition, toPosition, programId).pipe(
      this.programChildRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('update_program_section'),
      }),
    );
  };
}
